var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11 5.97071L6.27223 10.6985C5.06613 11.9046 3.11067 11.9046 1.90457 10.6985C0.698476 9.49238 0.698476 7.53691 1.90457 6.33082L6.63234 1.60305C7.43641 0.798984 8.74005 0.798984 9.54411 1.60305C10.3482 2.40711 10.3482 3.71076 9.54411 4.51482L4.8112 9.24259C4.40917 9.64462 3.75734 9.64462 3.35531 9.24259C2.95328 8.84056 2.95328 8.18874 3.35531 7.7867L7.72297 3.42419",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.cd5082f9.svg";
export { ForwardRef as ReactComponent };